import { FC, PropsWithChildren } from 'react';

import styled from '@emotion/styled';
import { dialogClasses } from '@mui/material/Dialog';

import { Button, IButtonProps } from '@web/ui/components';

import { IModalProps, Modal, ModalContent } from './index';

const Container = styled(Modal)`
  .${dialogClasses.paper} {
    max-width: 360px;
    gap: ${({ theme }) => theme.spacing('1500')};
    padding: ${({ theme }) => theme.spacing('2000')};
  }

  ${({ theme }) => theme.breakpoints.down('sm')} {
    .${dialogClasses.container}:after {
      vertical-align: bottom;
    }

    .${dialogClasses.paper} {
      max-width: inherit !important;
      box-sizing: border-box;
      width: 100%;
      margin: 0;
      border-radius: ${({ theme }) =>
        `${theme.shape.corner['1250']} ${theme.shape.corner['1250']} 0 0`};
    }
  }
`;

export const ConfirmDialogTitle = styled.span`
  font: ${({ theme }) => theme.typography.body.regular};
  font-size: ${({ theme }) => theme.typescale.size['4']};
  text-transform: ${({ theme }) => theme.textTransform.capitalize};
`;

export const ConfirmDialogContent = styled(ModalContent)`
  gap: ${({ theme }) => theme.spacing('1500')};
`;

const ActionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing('0500')};
`;

interface IConfirmDialogProps extends IModalProps {
  confirm: IButtonProps;
  cancel: IButtonProps;
}

export const ConfirmDialog: FC<PropsWithChildren<IConfirmDialogProps>> = ({
  confirm,
  cancel,
  children,
  ...props
}) => (
  <Container {...props}>
    {children}
    <ActionsContainer>
      <Button variant="warning" {...confirm} />
      <Button
        variant="secondary"
        background="surfaceContainerHigh"
        color="onSurface"
        {...cancel}
        onClick={cancel.onClick ?? props.onClose}
      />
    </ActionsContainer>
  </Container>
);
